/** Integrity + Secret Place vitals (speech lock lives on Game, not here). */

export interface ResourceState {
  integrity: number;
  maxIntegrity: number;
}

export function createResources(opts: {
  integrity: number;
}): ResourceState {
  return {
    integrity: opts.integrity,
    maxIntegrity: opts.integrity,
  };
}
